import React from 'react'
import styles from './EventsList.scss'
import PropTypes from 'prop-types'
import {urls} from 'lib/urls'
import {getTimeSpanStr} from 'lib/eventsUtils'
import {Icon} from 'common/Icon'

class EventsRow extends React.PureComponent {
  render () {
    const {event, color, showDateTime, showLocation, showOrganizers, showImage} = this.props

    return (
      <div className={styles.EventsRow}>
        <div className={styles.left}>
          {showDateTime && getTimeSpanStr(event)}
          <div className={styles.name}>
            <a href={`/events/${event.slug}`} style={{color: '#' + color}} target='_blank'>{event.name}</a>
          </div>
          {showLocation && event.location && <div className={styles.location}><Icon i='md-pin' className={styles.icon} /> {event.location}</div>}
          {showOrganizers && event.organizerNames && event.organizerNames.length > 0 &&
            <div className={styles.organzier}>
              Organizer{event.organizerNames.length > 1 && 's'}: {event.organizerNames.join(', ')}
            </div>}
        </div>
        {showImage && !!event.highlightedPhotoId && <div className={styles.right}>
          <img src={urls.photos.centi(event.highlightedPhotoId)} />
        </div>}
      </div>
    )
  }
}

export class EventsList extends React.PureComponent {
  static propTypes = {
    events: PropTypes.array.isRequired
  }

  render () {
    const {events, color, loaded, ...props} = this.props

    return (
      <div className={styles.EventsList}>
        {events.map((e) => <EventsRow key={e.id} event={e} color={color} {...props} />)}
        {loaded && events.length === 0 && <div className={styles.emptyList}>There are no upcoming events scheduled at this time</div>}
      </div>
    )
  }
}
